/**
 * @name WALLET_ENSURE_PAYMENTS_INFO_REQUEST
 * @description Invokes Wallet Manager to initialize/fetch Wallet data so it can be used
 * @example
 * window.caiEventBus.emit('wallet:ensurePaymentsInfo:request', {
 *    interestRates: { ... }, // custom interest rates
 * });
 */

/**
 * @name WALLET_ENSURE_PAYMENTS_INFO_COMPLETED
 * @description Triggered when Wallet Data is successfully initialized and ready for use
 * @returns Wallet data
 * @example
 * window.caiEventBus.on('wallet:ensurePaymentsInfo:completed', function({ paymentsInfo }) { ... });
 */

/**
 * @description Triggered when user updates fields in Wallet Modal
 * @returns Updated Wallet data
 * @example
 * window.caiEventBus.on('wallet:updated', function(walletData) { ... })
 */
export const WALLET_UPDATED = 'wallet:updated';

/**
 * @description Triggered only when UI is updated without user's interactions (e.g. success message that shows up on auto-sync completion)
 * @returns Updated Wallet UI
 * @example
 * window.caiEventBus.on('wallet:ui-updated', function(walletData) { ... })
 */
export const WALLET_UI_UPDATED = 'wallet:ui-updated';

/**
 * @description Triggered when user clicks Search Available Cars CTA from Wallet Modal
 * @returns Wallet data
 * @example
 * window.caiEventBus.on('wallet:search', function(walletData) { ... })
 */
export const WALLET_SEARCH = 'wallet:search';

/**
 * @description Retrieves the latest Wallet data
 * @returns Wallet data
 * @example
 * window.caiEventBus.emit('wallet:get', function(walletData) { ... })
 */
export const GET_WALLET = 'wallet:get';

/**
 * @description Updates user's Wallet data outside of Wallet Modal
 * @params Wallet data to update
 * @example
 * // Update Wallet data
 * window.caiEventBus.emit('wallet:set', { paymentsInfo: { downPaymentPercent: 0.2 } })
 */
export const SET_WALLET = 'wallet:set';

/**
 * @description Triggered to open Wallet Modal
 * @params {null|String} panel (optional) - null, creditScore, budget, downPayment, tradeIn
 * @params {String} modal (optional) - paymentDetails, wallet
 * @example
 * // Open Wallet Modal
 * window.caiEventBus.emit('wallet:open', { panel: 'creditScore' })
 *
 * // Open Payment Details Modal
 * window.caiEventBus.emit('wallet:open', { modal: 'paymentDetails', inventory: [{...inventory}] })
 *
 * // Listen
 * window.caiEventBus.on('wallet:open', function({ panel }) { ... })
 */
export const OPEN_WALLET = 'wallet:open';

/**
 * @description Triggered to close Wallet Modal
 * @example
 * // Close Wallet Modal
 * window.caiEventBus.emit('wallet:close')
 *
 * // Listen
 * window.caiEventBus.on('wallet:close', function() { ... })
 */
export const CLOSE_WALLET = 'wallet:close';

/**
 * @description Send's nds lead data
 * @example
 * // Send Lead Data
 * window.caiEventBus.emit('nds:lead', { ...paymentsInfo, ...tradeInfo, payment: "", salesPrice: "", lender: "", customReport: "" })
 */
export const SEND_LEAD = 'nds:lead';

/**
 * @description an event that requests wallet manager to open the SDP
 * @example
 * window.caiEventBus.emit('wallet:openSdp:request', { route: 'paymentOptions' })
 */
export const WALLET_OPEN_SDP_REQUEST = 'wallet:openSdp:request';

/**
 * @description an event sent by Wallet Manager when the open SDP event has completed
 * @example
 * window.caiEventBus.emit('wallet:openSdp:completed')
 */
export const WALLET_OPEN_SDP_COMPLETED = 'wallet:openSdp:completed';

/**
 * @description requests Wallet Manager to validate the deals by vin
 * @example
 * window.caiEventBus.emit('wallet:validateDealsByVin:request', ['vin1', 'vin2']);
 */
export const WALLET_VALIDATE_DEALS_BY_VIN_REQUEST = 'wallet:validateDealsByVin:request';

/**
 * @description Returns validated vins with an href to navigate to its vdp
 * @example
 * window.caiEventBus.emit('wallet:validateDealsByVin:completed', [{ vin: 'vin1', vdpUrl: 'href-to-vdp1' }, { vin: 'vin2', vdpUrl: 'href-to-vdp2' }]);
 */
export const WALLET_VALIDATE_DEALS_BY_VIN_COMPLETED = 'wallet:validateDealsByVin:completed';

/**
 * @description requests to open/trigger email dealer form
 * @example
 * window.caiEventBus.emit('wallet:emailDealer:request', { dealId: 'my-deal-id', vehicle object here });
 */
export const WALLET_EMAIL_DEALER_REQUEST = 'wallet:emailDealer:request';
